import { EPath } from "constants/path";
import { useAuth } from "contexts/AuthContext";
import { Navigate } from "react-router";

const HomePage: React.FC = () => {
  const { userClaims } = useAuth();
  // This is a doctor portal - only provider role is supported
  if (userClaims?.role === "provider") {
    return <Navigate to={EPath.PROVIDER_DASHBOARD} />;
  }
  return <div>HomePage</div>;
};

export default HomePage;
